var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"showAside":function($event){_vm.showAsideBar = true},"hideAside":function($event){_vm.showAsideBar = false}}}),_c('main',{staticClass:"pure-g"},[_c('aside',{staticClass:"pure-u-1",class:{
      'pure-u-md-8-24 pure-u-lg-6-24 pure-u-xl-5-24': _vm.showAsideBar,
      'hidden': !_vm.showAsideBar
    }},[_c('aside-bar')],1),_c('div',{staticClass:"pure-u-1 padding-half",class:{
      'pure-u-md-16-24 pure-u-lg-18-24 pure-u-xl-19-24': _vm.showAsideBar
    }},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }